import { hasHotelServiceCharges } from '../../helpers/hotelServiceChargesHelper';
import { convertToDualCurrency, priceAvailability } from '../../helpers/priceHelpers';
import { __ } from '../../helpers/TranslationService';
import { ICruiseReducer } from '../../interfaces';
import { IPageDataReducer } from '../../reducers/pageData';
import { IPerPersonPriceOverview } from '../PerPersonPriceOverview/PerPersonPriceOverview';

export const overviewPriceHelper = (
    pageData: IPageDataReducer,
    cruisePage: ICruiseReducer,
): IPerPersonPriceOverview => {
    const {
        currency,
        minPrice,
        soldOutBooking,
        sails,
        selectedSailIndex,
        includesFlight,
    } = cruisePage;

    const { exchangeRate } = pageData.header;

    const isDualCurrency = exchangeRate != null;

    const currentCurrency = isDualCurrency ? __('currency', 'dreamlines') : currency;

    const selectedSail = sails[selectedSailIndex];
    const maxDiscount = cruisePage.maxDiscount > 0 ? cruisePage.maxDiscount : 0;
    const departure = selectedSail?.departure || undefined;

    const pricing = priceAvailability(departure, soldOutBooking, minPrice, currency);

    const dualMinPrice = isDualCurrency && convertToDualCurrency(exchangeRate, minPrice);

    const dualPricing = priceAvailability(departure, soldOutBooking, dualMinPrice, currentCurrency);

    const hotelServiceChargesLabel = hasHotelServiceCharges(
        pageData.appConfig.countryCode,
        cruisePage.company.title,
        cruisePage.ship.title,
        departure,
    );

    return {
        price: pricing,
        dualCurrencyPrice: dualPricing,
        isDualCurrency: isDualCurrency,
        discount: maxDiscount,
        discountThreshold: pageData.discountThreshold,
        withFlight: includesFlight,
        hasHotelServiceCharges: hotelServiceChargesLabel,
        soldOutBooking: cruisePage?.soldOutBooking,
    };
};
